module.exports = __webpack_public_path__ + "media/Interface2.1b655419.wav";